import { s3AxiosInstance } from './axiosInstances.service';

export const uploadToS3 = (url: string, data: File, onProgress?: (e: any) => void, timeout: number = 0):Promise<void> => s3AxiosInstance.put(url, data, {
  headers: { 'Content-Type': 'video/webm' }, onUploadProgress: onProgress, timeout,
});
